var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"yx-color-primary cursor-pointer",on:{"click":function($event){return _vm.jumpMaterial(_vm.row)}}},[_vm._v(" "+_vm._s(_vm._f("formatEmpty")(_vm.row.material_count)))])
}
var staticRenderFns = []

export { render, staticRenderFns }